import { Injectable } from '@angular/core';
import { RoleOption } from '../models/roleOption';
import { TranslateService } from '@ngx-translate/core';
import { Role } from '../enums/role.enum';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(
    private translate: TranslateService,
  ) {}

  public getRoles(): RoleOption[] {
    return Object.values(Role).map((role) => ({
      label: this.translate.instant(`roles.${role}`),
      value: role,
    }));
  }

  // Si el idioma puede cambiar en runtime
  public getRoles$() {
    return this.translate.stream(
      Object.values(Role).map((role) => `roles.${role}`)
    ).pipe(
      map((translations) =>
        Object.values(Role).map((role) => ({
          value: role,
          label: translations[`roles.${role}`],
        }))
      )
    );
  }
}
